import React, { useCallback, useEffect, useState } from "react";
import { GameClubHeaderWrapper, GameClubTabWrapper } from "../Style/GameStyles";
import { ClubTab } from "../Hook/useGameClub";
import { useGameClubContext } from "../Hook/GameClubContext";
import {
  setNotificationAlert,
  getNotificationAlert,
} from "../../../../api/push";
import {
  GameMyPageNotificationWrapper,
  GameMyPageNotificationToggleWrapper,
  GameMyPageNotificationToggle,
} from "../Style/GameMyPageStyle";

export interface GameClubHeaderProps {
  isCalendarOpen: boolean;
  setIsCalendarOpen: (isCalendarOpen: boolean) => void;
}

export const GameClubHeader: React.FC<GameClubHeaderProps> = ({
  isCalendarOpen,
  setIsCalendarOpen,
}) => {
  const { isGameClubTab, setGameClubTab, gameClubTab } = useGameClubContext();
  const [isNotification, setIsNotification] = useState<boolean | null>(null);

  const handleNotificationToggle = useCallback(async () => {
    setIsNotification(!isNotification);
    await setNotificationAlert(!isNotification);
  }, [isNotification]);

  useEffect(() => {
    getNotificationAlert().then((res) => {
      setIsNotification(res.isNotification);
    });
  }, []);

  return (
    <GameClubHeaderWrapper>
      <div className="title-wrapper">
        <div className="left">
          <img
            src="/image-web/game/club/back.svg"
            alt="back"
            onClick={() => {
              setGameClubTab(ClubTab.MY);
            }}
          />
          <div className="title">
            {isGameClubTab(ClubTab.MEMBER) ? "클럽 유저" : "클럽 채팅"}
          </div>
        </div>
        {isNotification !== undefined &&
          isNotification !== null &&
          isGameClubTab(ClubTab.CHAT) && (
            <GameMyPageNotificationWrapper>
              <div className="title">알림</div>
              <GameMyPageNotificationToggleWrapper
                isNotification={isNotification}
                onClick={handleNotificationToggle}
              >
                <GameMyPageNotificationToggle isNotification={isNotification} />
              </GameMyPageNotificationToggleWrapper>
            </GameMyPageNotificationWrapper>
          )}
      </div>

      {isGameClubTab(ClubTab.MEMBER) && (
        <img
          src="/image-web/game/club/filter.svg"
          alt="filter"
          onClick={() => setIsCalendarOpen(true)}
        />
      )}
    </GameClubHeaderWrapper>
  );
};
